export const SubjectLevels = {
  PRIMARIA: 'Primaria',
  SECUNDARIA: 'Secundaria',
  BACHILLERATO: 'Bachillerato',
  FP: 'FP',
  UNIVERSIDAD: 'Universidad',
  IDIOMAS: 'Idiomas',
  TECNICAS: 'Técnicas de estudio',
  INTERNACIONAL: 'Internacional',
  OTRAS: 'Otras'
}
export const SubscriptionTypes = {
  pack: 'pack',
  rate: 'rate'
}
export const SubscriptionConfigTypes = {
  pack: 'pack',
  prepareMornings: 'prepareMornings',
  unlimited: 'unlimited',
  reinforces: 'reinforces',
  agora: 'agora',
  extraHours: 'extraHours'
}
export const SubscriptionTypeLabels = {
  pack: 'Pack',
  rate: 'Tarifa'
}

export const AttendanceStatusLabels = {
  planned: 'Planificada',
  imparted: 'Impartida',
  justified_absence: 'Falta jusificada',
  absence: 'Falta',
  canceled_by_app: 'Cancelado por el sistema'
}
export const AttendanceTypeLabels = {
  NORMAL: 'Normal',
  PLANA: 'Plana',
  INTENSIVO_PROMOCION: 'Intensivo promoción',
  ESPECIAL: 'Especial',
  CAMBIO: 'Cambio',
  PACK: 'Pack',
  PACK_PROMOCION: 'Pack promoción',
  GRATUITA: 'Gratuita',
  PRUEBA: 'Prueba',
  RECUPERACION: 'Recuperación',
  INTENSIVO: 'Intensivo',
  PROMOCION: 'Promoción',
  EXTRA: 'Extra',
  FORMACION: 'Formación'
}

export const AttendanceTypes = {
  NORMAL: 'NORMAL',
  PLANA: 'PLANA',
  INTENSIVO_PROMOCION: 'INTENSIVO_PROMOCION',
  ESPECIAL: 'ESPECIAL',
  CAMBIO: 'CAMBIO',
  PACK: 'PACK',
  PACK_PROMOCION: 'PACK_PROMOCION',
  GRATUITA: 'GRATUITA',
  PRUEBA: 'PRUEBA',
  RECUPERACION: 'RECUPERACION',
  INTENSIVO: 'INTENSIVO',
  PROMOCION: 'PROMOCION',
  EXTRA: 'EXTRA',
  FORMACION: 'FORMACION'
}
export const AttendanceStatus = {
  PLANNED: 'planned',
  IMPARTED: 'imparted',
  JUSTIFIED_ABSENCE: 'justified_absence',
  ABSENCE: 'absence',
  CANCELED_BY_APP: 'canceled_by_app'
}
export const TicketStatusLabels = {
  open: 'Abierto',
  closed: 'Cerrado'
}

export const SignedByTypes = {
  student: 'student',
  tutor: 'tutor'
}
export const SignedByLabels = {
  student: 'Estudiante',
  tutor: 'Tutor'
}

export const ClassSessionStatusLabels = {
  scheduled: 'Planificada',
  completed: 'Impartida',
  cancelled: 'Cancelada',
  absent: 'Ausente'
}

export const NormalizedLevel = {
  PRIMARY: 'PRIMARY',
  SECONDARY_LOW: 'SECONDARY_LOW',
  SECONDARY_HIGH: 'SECONDARY_HIGH',
  TERTIARY: 'TERTIARY'
}

export const SubLevel = {
  INTERNATIONAL: 'INTERNATIONAL'
}

export const NormalizedLevelLabels = {
  [NormalizedLevel.PRIMARY]: 'Primaria',
  [NormalizedLevel.SECONDARY_LOW]: 'ESO',
  [NormalizedLevel.SECONDARY_HIGH]: 'Bachillerato',
  [NormalizedLevel.TERTIARY]: 'Universidad / Accesos'
}

export const SubLevelLabels = {
  [SubLevel.INTERNATIONAL]: 'Internacional'
}

export const RATING_LABELS = {
  MUY_POSITIVA: '🤩',
  POSITIVA: '😊',
  NEUTRAL: '😐',
  NEGATIVA: '😞',
  MUY_NEGATIVA: '😭'
}
export const RATING_SCORES = {
  MUY_POSITIVA: 'MUY_POSITIVA',
  POSITIVA: 'POSITIVA',
  NEUTRAL: 'NEUTRAL',
  NEGATIVA: 'NEGATIVA',
  MUY_NEGATIVA: 'MUY_NEGATIVA'
}
